import React, { } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import configureStore from '../../redux/store'
import './App.css'
import Routes from './Routes'
import log from 'loglevel'
import CacheBuster from 'react-cache-buster'
import { version } from '../../../package.json'

const App = () => {
  const { store, persistor } = configureStore()
  const cacheVersion = version || '0.0.0'

  const level = process && process.env && process.env.NODE_ENV === 'development' ? 'debug' : 'warn'
  log.setLevel(level)
  log.info(`Logs initiated at level ${level}`)

  return (
    <CacheBuster
      version={cacheVersion}
      isEnabled
      isVerboseMode={false}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Routes />
        </PersistGate>
      </Provider>
    </CacheBuster>
  )
}

export default App
